import * as angular from 'angular';
import {IController} from "angular";

export class DeliveriesGroupSelectorCtrl implements IController {
  relation: any;

  private relationAgent: any;

  /* @ngInject */
  constructor() {
  }

  $onInit() {
    if (this.relation) {
      this.relationAgent = this.relation.details.agentId ? {
        id: this.relation.details.agentId,
        user: {
          firstName: this.relation.details.agentFirstName,
          lastName: this.relation.details.agentLastName
        }
      } : undefined;
    }
  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('relationsSubTableCardRow', {
    bindings: {
      relation: '<'
    },
    template: require('./relations-sub-table-card-row.html').default,
    controller: DeliveriesGroupSelectorCtrl
  });
